import { render } from "./WhyNeedHengxing.vue?vue&type=template&id=43be461e&scoped=true"
import script from "./WhyNeedHengxing.vue?vue&type=script&lang=js"
export * from "./WhyNeedHengxing.vue?vue&type=script&lang=js"

import "./WhyNeedHengxing.vue?vue&type=style&index=0&id=43be461e&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43be461e"]])

export default __exports__